import React, { useEffect, useState } from 'react';
import {
  HistroyArrow,
  NorthEastArrow,
  RecentListName,
  RecentSearchList,
} from './styled';

export default function RecentSearch(props) {
  const { recentSearch, recentSearchClickHandler, searchData } = props;
  const [latestString, setLatestString] = useState([]);

  useEffect(() => {
    let uniqueRecentSearch = new Set();
    for (let i = 0; i < recentSearch.length; i++)
      uniqueRecentSearch.add(recentSearch[i]);
    uniqueRecentSearch = Array.from(uniqueRecentSearch);
    if (uniqueRecentSearch.length > 0) {
      localStorage.setItem(
        'recentSearch',
        JSON.stringify(uniqueRecentSearch.join(',')),
        '/',
      );
    }
    setLatestString(uniqueRecentSearch);
  }, [recentSearch]);
  return (
    <>
      {latestString.length > 0 && searchData.length === 0 ? (
        <ul>
          {latestString?.map((element, index) => {
            if (index < 3)
              return (
                <li
                  key={`recentsearch${index}`}
                  onClick={(e) => recentSearchClickHandler(e, element, index)}
                >
                  <RecentSearchList>
                    <HistroyArrow src="/images/history_black.svg" alt="" />
                    <RecentListName>
                      {decodeURIComponent(element)}
                    </RecentListName>
                    <NorthEastArrow src="/images/north_east_arrow.svg" alt="" />
                  </RecentSearchList>
                </li>
              );
          })}
        </ul>
      ) : null}
    </>
  );
}
